var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research_course_warp"},[_c('iframe',{ref:_vm.uuid,staticClass:"research_course_iframe",attrs:{"src":_vm.iframeSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }